import {createStore} from 'vuex'
import {IRole, IUserInfo} from '@/types'

export default createStore({
  state: {
    // user information
    userInfo: null as IUserInfo | null
  },
  getters: {
    // Get roleCodeList of user.
    getRoleCodeList(state): string[] {
      if (!state.userInfo) return []
      else {
        return state.userInfo.roleList.map((role: IRole) => role.roleCode)
      }
    },
    // Get deptId of user.
    getDeptId(state) {
      if (!state.userInfo) return ''
      else {
        return state.userInfo.currentDept.deptId
      }
    },
    //设置userid
    userId(state) { 
      if (!state.userInfo) return ''
      else {
        return state.userInfo.userId
      }
    },
    //设置userid
    deptId(state) { 
      if (!state.userInfo) return ''
      else {
        return state.userInfo.currentDept.deptId
      }
    },
    userInfo(state) { 
      if (!state.userInfo) return ''
      else {
        return state.userInfo
      }
    }
  },
  mutations: {
    // Set user information.
    setUserInfo(state, userInfo: IUserInfo) {
      state.userInfo = userInfo
    },
    // clear user information.
    clearUserInfo(state) {
      state.userInfo = null
    }
  },
  actions: {},
  modules: {}
})
